import mediator from "@tvg/mediator";

export const onEnterPromoCodeGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_ENTER_PROMO_CODE",
    payload: {
      module
    }
  });

export const onApplyPromoCodeGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_APPLY",
    payload: {
      module
    }
  });

export const onPromoCodeAppliedGtmEvent = (eventLabel, module, promoCode) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_APPLIED",
    payload: {
      eventLabel,
      module,
      promoCode
    }
  });

export const onPromoCodeAppliedAutomaticallyGtmEvent = (module, promoCode) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_APPLIED_AUTOMATICALLY",
    payload: {
      module,
      promoCode
    }
  });

export const onPromoCodeRemovedGtmEvent = (eventLabel, module, promoCode) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_REMOVED",
    payload: {
      eventLabel,
      module,
      promoCode
    }
  });

export const onPromoCodeEditedGtmEvent = (eventLabel, module, promoCode) =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_EDITED",
    payload: {
      eventLabel,
      module,
      promoCode
    }
  });

export const onPromoCodeModalCloseGtmEvent = () =>
  mediator.base.dispatch({
    type: "REGISTRATION:PROMO_CODE_MODAL_CLOSED"
  });
